import { useMutation, useQueryClient } from "react-query";
import { useAxios } from "./useAxios";
import { BASE_API_URL } from "../utils/app-constants";

export const SOURCING_PRODUCT_RESEND_EMAIL_URL = (id) =>
  `${BASE_API_URL}sourcing-product/${id}/resend-email`;

// Re-sends the LPO email. Resolves with the updated sourcing record, whose
// email_status is "sent" or "failed".
export const useResendSourcingEmail = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation(
    (id) =>
      axios
        .post(SOURCING_PRODUCT_RESEND_EMAIL_URL(id))
        .then((res) => res.data.returned_resultset[0]),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("sourced-products");
      },
    },
  );
};